import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, StarIcon, QuoteIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const [index, setIndex] = useState(0);
  const items = t.testimonials.items;
  const active = items[index % items.length];
  const go = (delta: number) => setIndex(prev => (prev + delta + items.length) % items.length);
  return <section className="bg-mist py-20 sm:py-24" data-id="element-301" data-mp="32290u6mgwl4n">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-302" data-mp="2x1uqghxe8z3g">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-303" data-mp="2s1qaqu4b88ea">
          <SectionHeading kicker={t.testimonials.kicker} title={t.testimonials.title} subtitle={t.testimonials.subtitle} data-id="element-304" data-mp="2s42wzjh3p4x5" />
          <div className="flex gap-2" data-id="element-305" data-mp="qavddxugg15g">
            <button type="button" onClick={() => go(-1)} aria-label={t.testimonials.prev} className="flex h-10 w-10 items-center justify-center rounded-lg border border-navy/15 bg-white text-navy transition-colors duration-150 hover:border-brand-blue hover:text-brand-blue" data-id="element-306" data-mp="h5yamk89jn69">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-307" data-mp="c7mz852bl4lx" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label={t.testimonials.next} className="flex h-10 w-10 items-center justify-center rounded-lg border border-navy/15 bg-white text-navy transition-colors duration-150 hover:border-brand-blue hover:text-brand-blue" data-id="element-308" data-mp="zxhc2mmn2t66">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-309" data-mp="v3d0fq2fhwyr" />
            </button>
          </div>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-3" data-id="element-310" data-mp="1nlqs17x68mpe">
          <div className="rounded-xl bg-navy p-8 shadow-card lg:col-span-2" data-id="element-311" data-mp="1nnbleu7r1zlo">
            <QuoteIcon className="h-8 w-8 text-brand-cyan" aria-hidden="true" data-id="element-312" data-mp="1xgpmnjb994br" />
            <AnimatePresence mode="wait" data-id="element-313" data-mp="1sio36x9x32zr">
              <motion.blockquote key={active.name + active.quote} initial={{
              opacity: 0,
              y: 8
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -8
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-314" data-mp="1sgtfxcb6aysi">
                <p className="mt-5 font-display text-2xl font-bold leading-snug text-white sm:text-3xl" data-id="element-315" data-mp="1ekzibpfunvup">
                  “{active.quote}”
                </p>
                <footer className="mt-6 flex items-center gap-3" data-id="element-316" data-mp="14u4vojyoyu8q">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-orange font-display text-base font-bold text-white" data-id="element-317" data-mp="10s9tld8xsctw">
                    {active.name.charAt(0)}
                  </span>
                  <span data-id="element-318" data-mp="qulobtdpfmxh">
                    <span className="block text-sm font-semibold text-white" data-id="element-319" data-mp="quc6it2tcm2v">{active.name}</span>
                    <span className="block text-xs text-white/60" data-id="element-320" data-mp="32gnt6sxrnh3v">{active.meta}</span>
                  </span>
                  <span className="ml-auto flex gap-0.5" aria-label="5 / 5" data-id="element-321" data-mp="37i3emm3uvpms">
                    {Array.from({
                    length: 5
                  }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-brand-orange text-brand-orange" aria-hidden="true" data-id="element-322" data-mp="3gh6wxnv78108" data-mpi={i} />)}
                  </span>
                </footer>
              </motion.blockquote>
            </AnimatePresence>
          </div>

          <ul className="grid gap-3" data-id="element-323" data-mp="2sozxgfu6fdwl">
            {items.map((item, i) => <li key={item.name + item.quote} data-id="element-324" data-mp="2xjdt8jcr3n1s" data-mpi={i}>
                <button type="button" onClick={() => setIndex(i)} aria-current={i === index} className={`w-full rounded-lg border px-4 py-3 text-left text-sm transition-colors duration-150 ${i === index ? 'border-brand-orange bg-white text-navy' : 'border-transparent bg-white/70 text-ink/70 hover:bg-white'}`} data-id="element-325" data-mp="2106ggfvy9wly">
                  <span className="block font-semibold" data-id="element-326" data-mp="1qvzuhl6mz6t4">{item.name}</span>
                  <span className="mt-0.5 block truncate text-xs text-ink/60" data-id="element-327" data-mp="1quos9psua744">{item.meta}</span>
                </button>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}